import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Contributor from "../contributor";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";

import { getStoryData, generateImageSources } from "../../utils/utils";
import { isPremium } from "../../../data/story";

import styles from "./styles.m.css";

const StoryCardVertical = ({
  story,
  className = "",
  cardWithImageZoom = true,
  hasTruncatedHeadline = true,
  authorName = true,
  utmURL = "",
  cardcollection = true,
  openInNewTab = false,
  withoutcard = false,
  isMyVikatanPage = false
}) => {
  const storyData = getStoryData(story);

  if (!storyData.headline || !story["url"]) {
    return null;
  }

  const contributor = get(story, ["authors", 0]);
  const contributorRole = get(story, ["contributors", 0, "role-name"], "");
  const externalLink = get(story, ["metadata", "reference-url"]);

  return (
    <div
      className={`${className} ${styles["base"]} ${
        withoutcard ? styles["withoutcardtrue"] : styles["withoutcardfalse"]
      }`}
    >
      <Link
        aria-label={`${"Read full story: "} ${storyData.headline}`}
        className={`${styles["link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""} ${className} ${
          cardcollection ? styles["card-one"] : styles["card-two"]
        } ${isMyVikatanPage ? styles["ismyvikatanpagetrue"] : styles["ismyvikatanpagefalse"]}`}
        href={`${externalLink || story.url}?pfrom=${utmURL}`}
        externalLink={`${story.url}?pfrom=${utmURL}`}
      >
        <div className={styles["layout"]}>
          <div className={styles["image-container"]}>
            <ResponsiveImageWithFallback
              className={styles["image-wrapper"]}
              slug={storyData.imageS3Key}
              metadata={storyData.imageMetadata}
              isPremium={isPremium(story)}
              alt={storyData.imageCaption}
              imgParams={{ auto: ["format", "compress"] }}
              sources={generateImageSources(
                { aspectRatio: [5, 4], screenWidthCoverage: 0.35 },
                { aspectRatio: [4, 3], screenWidthCoverage: 0.12 }
              )}
              story={story}
            />
          </div>
          <div className={`${styles["text-wrapper"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
            {(isMyVikatanPage || !authorName) &&
              contributor && (
                <Contributor
                  name={contributor["name"]}
                  type={contributorRole}
                  iconColor="#4a4a4a"
                  className={`${styles["contributor"]} ${
                    authorName ? styles["authornametrue"] : styles["authornamefalse"]
                  }`}
                />
              )}
            <h3 className={styles["headline"]}>{storyData.headline}</h3>
          </div>
        </div>
      </Link>
    </div>
  );
};

StoryCardVertical.propTypes = {
  className: PropTypes.string,
  cardWithImageZoom: PropTypes.bool,
  hasTruncatedHeadline: PropTypes.bool,
  authorName: PropTypes.bool,
  utmURL: PropTypes.string,
  cardcollection: PropTypes.string,
  openInNewTab: PropTypes.bool,
  withoutcard: PropTypes.bool,
  isMyVikatanPage: PropTypes.bool,
  story: PropTypes.shape({
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

export default StoryCardVertical;
